import { ReloadOutlined } from '@ant-design/icons'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useSelfLoading } from '@eastcoal/common/hooks/useSelfLoading'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../enums/FormMode'
import { useCrudFormStore } from '../../Store/hooks/useStore'

export const RefreshButton = () => {
  const { mode, readLoading, reloadDetail } = useCrudFormStore(state =>
    pick(state, ['mode', 'readLoading', 'reloadDetail'])
  )

  const { loading, onClick } = useSelfLoading({
    loading: readLoading,
    onClick: reloadDetail
  })

  return mode === FormMode.READ ? (
    <ThrottleButton
      disabled={readLoading}
      icon={<ReloadOutlined />}
      loading={loading}
      onClick={onClick}
    >
      刷新
    </ThrottleButton>
  ) : null
}
